import { Check, Clock } from 'lucide-react';
import StatusBadge from 'components/StatusBadge';
import Picture from './Picture';

const PLACEHOLDER = { text: 'Not provided', pills: 'Nothing selected', image: 'Not added' };

const Placeholder = ({ text }) => <p className="text-sm text-secondary-300">{text}</p>;

const Value = ({ type, value, empty }) => {
  if (type === 'status')
    return (
      <StatusBadge
        status={value ? 'Agreed' : 'Not agreed'}
        className={value ? 'bg-success-50 text-green-700 border-green-200' : 'bg-gray-100 text-secondary-500 border-gray-200'}
        icon={value ? Check : Clock}
      />
    );

  if (type === 'pills')
    return value?.length ? (
      <div className="flex flex-wrap gap-2">
        {value.map((item, index) => (
          <span
            key={`pill-${item}-${index}`}
            title={item}
            className="max-w-[min(100%,15rem)] truncate rounded-full border border-blue-100 bg-blue-50 px-3 py-1.5 text-xs font-semibold text-teamcare-blue-dark"
          >
            {item}
          </span>
        ))}
      </div>
    ) : (
      <Placeholder text={empty || PLACEHOLDER.pills} />
    );

  if (type === 'image') {
    const pictures = value || [];

    if (!pictures.some(({ url }) => url)) return <Placeholder text={empty || PLACEHOLDER.image} />;

    return (
      <div className={`grid grid-cols-1 gap-3 ${pictures.length > 1 ? 'sm:grid-cols-2' : ''}`}>
        {pictures.map(({ label, url }, index) => (
          <Picture key={label || index} label={label} url={url} />
        ))}
      </div>
    );
  }

  return value ? (
    <p className="break-words text-sm font-semibold text-secondary-900">{value}</p>
  ) : (
    <Placeholder text={empty || PLACEHOLDER.text} />
  );
};

const Row = ({ label = '', value, type = 'text', hint = '', empty = '', stacked = false }) => (
  <div className={`px-4 py-3.5 sm:px-5 ${stacked ? '' : 'flex items-start justify-between gap-4'}`}>
    {label && (
      <div className="min-w-0">
        <p className="text-[13px] text-secondary-500">{label}</p>
        {hint && <p className="mt-0.5 text-xs text-secondary-400">{hint}</p>}
      </div>
    )}

    <div className={stacked ? (label ? 'mt-2.5' : '') : 'flex min-w-0 flex-1 justify-end text-right'}>
      <Value type={type} value={value} empty={empty} />
    </div>
  </div>
);

export default Row;
